import React from 'react'
import styled from '@emotion/styled'
import useProgressBar from '../../hooks/components/useProgressBar'
import BreadcrumbWebComponentWrapper from './BreadcrumbWebComponentWrapper'

export default props => {
  const { year, make, model, trim, vinResults, urlState, globalState, mileage, experienceState } = props
  const { theme } = experienceState
  let progressBar = null
  const { stepClick, showProgressBar, currentPage, pages } = useProgressBar({ ...props })
  ////// **** - Integrated Breadcrumb Code - **** //////
  let vehicleName = ''
  let vehicleTrim = ''
  if (globalState) {
    const vin = vinResults && vinResults.vin ? vinResults.vin : urlState.vin
    if (year && make && model) {
      vehicleName = `${year.displayName} ${make.displayName} ${model.displayName}`
    }
    if (trim) {
      vehicleTrim = trim.displayName
    }
    progressBar = <BreadcrumbWebComponentWrapper vehicleName={vehicleName} trim={vehicleTrim} vin={vin} currentStep={currentPage} pages={pages} stepClick={stepClick} mileage={mileage} theme={theme} />
  }

  ////// **** - This is NEEDED for Array Parameters, stencil is weird (https://stenciljs.com/docs/properties#array-props)  - **** //////
  if (document.querySelector('ico-breadcrumb')) {
    document.querySelector('ico-breadcrumb').pages = pages
  }
  ////// **** - Integrated Breadcrumb Code - **** //////
  return showProgressBar && <StyledDiv data-testid={`global-progressBar`} className={`${theme}-theme`}>{progressBar}</StyledDiv>
}

const StyledDiv = styled.div`
  display: flex;
  width: 100%;
  max-width: 1024px;
  z-index: 2;
`
